import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSnapshot } from "valtio";
import { QUERY_KEYS } from "@/src/config";
import { OspApiClientContext } from "@/src/features";
import { rootStore } from "@/src/store";

export const useMemberRetentionStats = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { memberApi } = useContext(OspApiClientContext);
  const { ownerInfo } = useSnapshot(rootStore.user);

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.MEMBER_RETENTION_STATS, ownerInfo?.id],
    enabled: enabled && !!memberApi && !!ownerInfo?.id,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const res = await memberApi?.members?.getMemberRetentionStats();
      return res?.data?.data;
    },
  });

  return {
    data,
    ...rest,
  };
};
